import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import { getSelectedOrder } from '../../../../../../selectors/tools';
import SearchHeaderText from './SearchHeaderText/SearchHeaderText';
import SearchHeaderResultsText from './SearchHeaderResultsText/SearchHeaderResultsText';

const SearchHeader = () => {
  const selectedOrder = useSelector(getSelectedOrder);

  if (isEmpty(selectedOrder)) {
    return <SearchHeaderResultsText />;
  }

  return <SearchHeaderText text={'Please select only the items the customer is inquiring about'} />;
};

export default SearchHeader;
